module.exports = __webpack_public_path__ + "img/26.a9fd0c52.jpg";